module.exports = __webpack_public_path__ + "img/9791158884826.69df9098.jpg";